export const reviewData = {
	heading: {
		title: 'Frequently Asked Questions',
		subtitle: 'Who are in extremely love with eco friendly system.',
	},

	reviewList: [
		{
			title: 'Cody Hines',
			txt:
				'Accessories Here you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker.',
			rating: 3,
		},
		{
			title: 'Chad Herrera',
			txt:
				'Accessories Here you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker.',
			rating: 2,
		},
		{
			title: 'Andre Gonzalez',
			txt:
				'Accessories Here you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker.',
			rating: 2,
		},
		{
			title: 'Jon Banks',
			txt:
				'Accessories Here you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker.',
			rating: 4,
		},
		{
			title: 'Landon Houston',
			txt:
				'Accessories Here you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker.',
			rating: 1,
		},
		{
			title: 'Nelle Wade',
			txt:
				'Accessories Here you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker.',
			rating: 5,
		},
	],
};
